import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { NotificationsContextEnum } from '@core/store/models/notifications.enum';
// core recorder state 
import * as fromState from '@core/store/state/recorder/recorder.state';
// services
import { RecorderService } from '@core/services/recorder/recorder.service';
// import { ClickEventManagerService } from '@core/services/click-manager/click-manager.service';


@Component({
    selector: 'core-layout-modals-overlapped',
    templateUrl: './modals-overlapped.component.html',
    styleUrls: ['./modals-overlapped.component.scss']
})
export class CoreLayoutOverlappedModalsComponent implements OnInit, OnDestroy {
    
    
    public readonly NOTIFICATION_TYPES = NotificationsContextEnum;
    // use here record store to manage when to show this.

    public showPlayer: boolean = false;
    public showDone: boolean = false;
    public showError: boolean = false;
    public showPipCam: boolean = false;
    // this manage the click event.
    // private clickEventStopRecordSubscription: Subscription;
    private recordStatusSubscription: Subscription;
    constructor(
        // private clickEventManagerService: ClickEventManagerService,
        private recorderSrv: RecorderService) {}

    ngOnInit(){
        // NOTE : this has to ve asyncornous.
        // NOTE about ClickEventManagerService: this code is the version of managing notification clcik action to open the modal
        // const event = this.clickEventManagerService.getClickEvent(this.NOTIFICATION_TYPES.ACTION_RECORD_STOP);
        // if (event) {
        //     this.clickEventStopRecordSubscription = event.subscribe(() => {
        //         console.debug('Click on event:'+this.NOTIFICATION_TYPES.ACTION_RECORD_STOP, event);
        //         // Perform action here
        //         this.openPlayer();
        //     });
        // } else {
        //     console.debug('Click event does not exist');
        // }

        // listen record store status to manage notification action to open the modal
        this.recordStatusSubscription = this.recorderSrv.getStatus().subscribe((status: fromState.RecorderStatus ) => {
            // console.debug(" STATUS RECORDER is ",status);
            if(status == fromState.RecorderStatus.STOPPED){
                // Perform action here to show the modal
                this.openPlayer();
            }
            if(status == fromState.RecorderStatus.STARTED ||
                status == fromState.RecorderStatus.RECORDING){
                //  console.debug(" STATUS RECORDER is STARTED showPipCam ",status);
                this.showPipCam = true;
            } else {
                this.showPipCam = false;
            }
            if(status == fromState.RecorderStatus.FINISHED_SUCCESS){
                // Perform action here to show the modal
                this.showDone = true;
            }
            
            // TODO: Show failed.
            if(status == fromState.RecorderStatus.FINISHED_ERROR){
                // Perform action here to show the modal
                this.showError = true;
            }
        })
    }

    ngOnDestroy(): void {
        // this.clickEventStopRecordSubscription.unsubscribe();
        this.recordStatusSubscription.unsubscribe();
    }


    openPlayer():void {
        this.showPlayer = true;
    }

    onRecordSave(): void {
        this.showPlayer = false;
        this.showDone = true;
    }

    onRecordCancel(): void {
        this.showPlayer = false;
        this.recorderSrv.clear();
    }

    onMessageSent():void{
        this.showDone = false;
        this.recorderSrv.clear();
    }
    
    onMessageError():void{
        this.showError = false;
        this.recorderSrv.clear();
    }

}
